import { useEffect } from "react";
import { useNavigate } from "react-router";
import { Screen, usePodContext } from "../PodContext";
import Button from "./Button";
import Footer from "./Footer";
import "./Home.css";
import Text from "./Text";

const Home = () => {
  const navigate = useNavigate();
  const { resetChoices } = usePodContext();

  useEffect(resetChoices, [resetChoices]);

  return (
    <div className="vr-home-container">
      <div className="vr-home-content">
        <div className="vr-home-centered">
          <Text type="title">Welcome to</Text>
          <img
            src="/assets/logos/Updated-Cabana-Pod-Logo.png"
            alt="logo"
            className="cabana-pod-logo"
          />
        </div>
        <Text className="text-center">{`Recharge and feel better in 5 minutes\nwith our guided exercises.`}</Text>
        <Button
          text="Start now"
          filled
          onClick={() => navigate(Screen.DISCLAIMER)}
        />
        <Footer />
      </div>
      <div className="vr-home-video-container">
        <video className="vr-home-video" autoPlay loop muted playsInline>
          <source src="/assets/video/start-screen.mp4" type="video/mp4" />
        </video>
      </div>
    </div>
  );
};

export default Home;
